import React, { Component } from "react";
import { connect } from "react-redux";
import {
	triggerDialog,
	setLoading,
	reload,
	triggerNotification,
	triggerDialogForm,
} from "../../../../actions";
import { translationHook } from "../../../translationHook";
import apiConfig from "../../../../apis/apiConfig";
import {
	ButtonPrimary,
	ButtonDanger,
	ButtonInfo,
	ButtonWarning,
} from "../../../UI/Buttons";
import { Link } from "@reach/router";
import {
	DataGrid,
	Column,
	Button,
	SearchPanel,
	FilterRow,
	HeaderFilter,
	ColumnChooser,
	Export,
	Grouping,
	GroupPanel,
	Selection,
	StateStoring,
	Pager,
	Paging,
} from "devextreme-react/data-grid";
import { deleteAgent } from "../../../../apis/charity/agents/deleteAgent";
import { setAgentStatus } from "../../../../apis/charity/agents/setAgentStatus";
import { getAgentDetails } from "../../../../apis/charity/agents/getAgentDetails";
import { getDonationTypesList } from "../../../../apis/charity/donationTypes/getDonationTypesList";
import { setTypeStatus } from "../../../../apis/charity/donationTypes/setTypeStatus";
import { deleteType } from "../../../../apis/charity/donationTypes/deleteType";
import { getTypeDetails } from "../../../../apis/charity/donationTypes/getTypeDetails";

import CustomStore from "devextreme/data/custom_store";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ExcelJS, Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToExcel } from "devextreme/excel_exporter";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import TypeForm from "./TypeForm";

class DonationTypesList extends Component {
	constructor(props) {
		super(props);
		this.onExporting = this.onExporting.bind(this);
		this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
		this.devRef = React.createRef(null);
		this.searchState = React.createRef();
	}

	state = {
		gridState: [],
		gridKey: "",
		filterResults: 0,
		showGrid: false,
		searchResults: 0,
		saveGrid: false,
		pageSize: null,
		focusRow: -1,
		typesList: [],
		showAddBtn: false,
	};

	getTypesList = async () => {
		let at = this.props.currentUser.Data.access_token;

		const response = await getDonationTypesList(at);

		if (response?.data) {
			this.setState({
				typesList: response?.data?.Data,
			});
		}
	};

	customizeCellCheckbox = ({ data }) => {
		return (
			<FormControlLabel
				control={
					<Switch
						checked={data.Active_Status_Id}
						name={`forbiddenNameStatus_${data.Donation_Type_Id}`}
						onChange={async () => {
							let at = this.props.currentUser.Data.access_token,
								typeId = data.Donation_Type_Id,
								status = data.Active_Status_Id ? 0 : 1;

							this.props.setLoading(true, "dark");

							await setTypeStatus(at, typeId, status).then(
								(res) => {
									this.props.triggerNotification(true, res);
									this.getTypesList();
								}
							);

							this.props.setLoading(false);
						}}
					/>
				}
			/>
		);
	};

	handleDeleteType = async (at, typeId) => {
		let result;

		await deleteType(at, typeId).then((res) => {
			if (res.Status) {
				result = res;
				this.getTypesList();
			}
		});

		return result;
	};

	handleDelete = (data) => {
		let at = this.props.currentUser.Data.access_token,
			typeId = data.Donation_Type_Id,
			typeName =
				this.props.i18n.language === "ar"
					? data.Donation_Type_Name_AR
					: data.Donation_Type_Name_EN,
			dialogTitle = `${this.props.t("confirmDeleteTitle")} ${typeName}`,
			dialogMsg = this.props.t("confirmDeleteMsg");

		this.props.triggerDialog(true, {
			title: dialogTitle,
			message: dialogMsg,
			action: {
				action: this.handleDeleteType,
				params: [at, typeId],
				text: this.props.t("deleteType"),
			},
		});
	};

	renderForm = (...params) => {
		let viewMood = params[2] === "view" ? true : false,
			editMood = params[2] === "edit" ? true : false;

		return (
			<TypeForm
				typeId={params[0]}
				initValues={params[1]}
				editMood={editMood}
				viewMood={viewMood}
				submitCB={this.getTypesList}
			/>
		);
	};

	handleEdit = async (data, viewMood) => {
		let at = this.props.currentUser.Data.access_token,
			typeId = data.Donation_Type_Id;

		this.props.setLoading(true, "dark");

		await getTypeDetails(at, typeId).then((res) => {
			if (res.data.Status) {
				let {
						Active_Status_Id,
						Donation_Type_Name_AR,
						Donation_Type_Name_EN,
						Start_Balance_Value,
						Donation_Type_Id,
					} = res.data.Data,
					initValues = {
						Active_Status_Id,
						Donation_Type_Name_AR,
						Donation_Type_Name_EN,
						Start_Balance_Value,
						Donation_Type_Id,
					},
					typeId = Donation_Type_Id,
					agentName =
						this.props.i18n.language === "ar"
							? Donation_Type_Name_AR
							: Donation_Type_Name_EN,
					dialogTitle = `${
						viewMood === "view"
							? this.props.t("view")
							: this.props.t("edit")
					} ${agentName}`;

				this.props.triggerDialogForm(true, {
					title: dialogTitle,
					renderForm: this.renderForm,
					params: [typeId, initValues, viewMood],
				});
			}
		});

		this.props.setLoading(false);
	};

	saveState = async () => {
		const at = this.props.currentUser.Data.access_token,
			url = "API/SYSTEM/GENERAL/SAVE_USER_GRID_SETTINGS",
			bodyData = {
				System_Grid_Name: "Grid_Chrty_LKP_Donations_Types",
				System_Grid_Json: this.searchState.current,
				Lang: this.props.i18n.language,
			};

		await apiConfig.post(url, bodyData, {
			headers: {
				Authorization: `Bearer ${at}`,
			},
		});

		this.props.triggerNotification(true, {
			Status: true,
		});
	};

	getState = async (state) => {
		if (state) {
			state.searchText = "";
			state.columns.map((s) => (s.filterValue = undefined));
			this.searchState.current = JSON.stringify(state);
		}
	};

	loadState = async () => {
		const at = this.props.currentUser.Data.access_token,
			url = "API/SYSTEM/GENERAL/GET_USER_GRID_SETTINGS",
			bodyData = {
				System_Grid_Name: "Grid_Chrty_LKP_Donations_Types",
				Lang: this.props.i18n.language,
			};

		const response = await apiConfig.post(url, bodyData, {
			headers: {
				Authorization: `Bearer ${at}`,
			},
		});

		if (response.data) {
			this.setState({
				gridState: JSON.parse(response?.data?.Data),
				showGrid: true,
				pageSize: JSON.parse(response?.data?.Data)?.pageSize,
			});
		}
	};

	onToolbarPreparing(e) {
		e.toolbarOptions.items.unshift(
			{
				location: "after",
				widget: "dxButton",
				options: {
					text: this.props.t("saveGridSettings"),
					height: "36px",
					icon: "save",
					onClick: () => this.saveState(),
					hint: this.props.t("saveGridSettings"),
				},
			},
			{
				location: "after",
				widget: "dxButton",
				options: {
					text: this.props.t("clearSearch"),
					height: "36px",
					icon: "clearformat",
					onClick: () => this.dataGrid?.instance?.clearFilter(),
					hint: this.props.t("clearSearch"),
				},
			}
		);
	}

	handleOnContentReady = (e) => {
		if (this.props.i18n.language === "ar") {
			const scrollable = e.component.getScrollable();
			const maxScrollLeft = scrollable?.scrollWidth();

			scrollable?.scrollTo({
				x: maxScrollLeft,
			});
		}
	};

	componentDidMount() {
		(async () => {
			await this.getTypesList();
		})();

		this.setState({ showGrid: false, saveGrid: false });
		this.dataGrid?.instance?.clearFilter();
		this.loadState();
	}

	render() {
		const jsonDataSource = new CustomStore({
			key: "Donation_Type_Id",
			load: () => {
				return this.state.typesList;
			},
		});

		return (
			<>
				<TypeForm submitCB={this.getTypesList} />

				<DataGrid
					className={`${[
						this.props.i18n.language === "ar"
							? "dx-grid-ar"
							: "dx-grid-en",
						"globalBox ",
						this.state.showGrid ? "d-block" : "d-none",
					].join(" ")} `}
					id="dataGrid"
					width={"100%"}
					dataSource={jsonDataSource}
					showBorders={false}
					zshowColumnLines={false}
					showRowLines={true}
					allowColumnResizing={true}
					columnResizingMode={"widget"}
					allowColumnReordering={true}
					rowAlternationEnabled={false}
					focusedRowEnabled={true}
					onExporting={this.onExporting}
					wordWrapEnabled={true}
					onToolbarPreparing={this.onToolbarPreparing}
					bounceEnabled={false}
					onOptionChanged={(e) => {
						if (e?.fullName == "paging.pageSize") {
							this.setState({ pageSize: e.value });
						}

						if (e.fullName.split(".").pop() == "filterValue") {
							this.dataGrid.instance.refresh();
						}
					}}
					onContentReady={this.handleOnContentReady}
					remoteOperations={false}
					rtlEnabled={
						this.props.i18n.language === "ar" ? true : false
					}
					ref={(ref) => (this.dataGrid = ref)}
				>
					<ColumnChooser
						enabled={true}
						allowSearch={true}
						search={"fff"}
						title={this.props.t("dxColumnChooserTitle")}
						emptyPanelText={this.props.t(
							"dxColumnChooserPanelText"
						)}
					/>

					<Pager
						visible="true"
						allowedPageSizes={[5, 10, 20, 50, 100]}
						displayMode="full"
						showPageSizeSelector="true"
						showInfo="true"
						infoText=""
						showNavigationButtons="true"
					/>

					<Paging
						enabled={true}
						defaultPageSize={this.state.pageSize}
						pageSize={this.state.pageSize}
					/>

					<StateStoring
						enabled={true}
						type="custom"
						// customLoad={this.loadState}
						customSave={this.getState}
					/>

					<SearchPanel
						visible={true}
						width={240}
						placeholder={this.props.t("search")}
					/>

					<FilterRow visible={true} applyFilter={true} />

					<HeaderFilter visible={true} />

					<Export enabled={true} allowExportSelectedData={true} />

					<Grouping contextMenuEnabled={true} expandMode="rowClick" />

					<GroupPanel
						visible={true}
						emptyPanelText={this.props.t("dxGroupPanelText")}
					/>

					{/* <Selection
						mode="multiple"
						selectAllMode={"allPages"}
						showCheckBoxesMode={"always"}
					/> */}

					{this.state.gridState?.columns
						?.filter(
							(d) =>
								d.name !== "buttons" &&
								d.name !== "Active_Status_Id"
						)
						.map((d, i) => {
							if (d.dataType == "date") {
								return (
									<Column
										dataField={d.dataField}
										caption={d.name}
										alignment={
											this.props.i18n.language === "ar"
												? "right"
												: "left"
										}
										visible={d.visible}
										width={d.width ? d.width : "auto"}
										dataType={d.dataType}
										format={
											d.dataType == "date"
												? "yyyy-MM-dd"
												: ""
										}
										sortIndex={0}
										sortOrder="desc"
									></Column>
								);
							} else {
								return (
									<Column
										dataField={d.dataField}
										caption={d.name}
										alignment={
											this.props.i18n.language === "ar"
												? "right"
												: "left"
										}
										visible={d.visible}
										width={d.width ? d.width : "auto"}
										dataType={d.dataType}
										defaultSortOrder="asc"
									></Column>
								);
							}
						})}

					<Column
						dataField="Active_Status_Id"
						caption={this.props.t("serviceStatus")}
						allowFiltering={false}
						alignment={"center"}
						width={"100px"}
						cellRender={this.customizeCellCheckbox}
					></Column>

					<Column
						cssClass="outlinedColumn nowrapColumn"
						type="buttons"
						caption={this.props.t("details")}
						fixed={true}
						fixedPosition={
							this.props.i18n.language === "ar" ? "left" : "right"
						}
					>
						<Button
							render={(record) => {
								return (
									<ButtonWarning
										variant="circleIcon"
										startIcon={<EditIcon />}
										onClick={() => {
											this.handleEdit(
												record.data,
												"edit"
											);
										}}
									></ButtonWarning>
								);
							}}
						/>

						{/* <Button
							render={(record) => {
								return (
									<ButtonInfo
										variant="circleIcon"
										startIcon={<VisibilityIcon />}
										onClick={() => {
											this.handleEdit(
												record.data,
												"view"
											);
										}}
									>
									</ButtonInfo>
								);
							}}
						/> */}

						<Button
							render={(record) => {
								return (
									<ButtonDanger
										variant="circleIcon"
										startIcon={<DeleteIcon />}
										onClick={() =>
											this.handleDelete(record.data)
										}
									>
										{/* {this.props.t('delete')} */}
									</ButtonDanger>
								);
							}}
						/>
					</Column>
				</DataGrid>
			</>
		);
	}

	onExporting(e) {
		let sheetTitle = this.props.t("licensesTrademarkNamesList");
		const workbook = new Workbook();
		const worksheet = workbook.addWorksheet("Main sheet");
		exportDataGridToExcel({
			component: e.component,
			worksheet: worksheet,
			autoFilterEnabled: true,
			topLeftCell: { row: 2, column: 2 },
			topRightCell: { row: 2, column: 2 },
			customizeCell: ({ gridCell, excelCell }) => {
				// excelCell.value = gridCell.value;
				excelCell.font = {
					family: 2,
					name: "Cairo",
					size: 10,
					color: { argb: "151713" },
				};
				excelCell.alignment = {
					indent: 1,
					wrapText: true,
					vertical: "middle",
				};
				if (gridCell.rowType === "group") {
					excelCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "d0b166" },
					};
					excelCell.alignment = { indent: 2 };
					excelCell.font = {
						family: 2,
						name: "Cairo",
						size: 10,
						color: { argb: "ffffff" },
						bold: true,
					};
				}
				if (gridCell.rowType === "header") {
					excelCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "58743a" },
					};
					excelCell.alignment = {
						vertical: "middle",
						horizontal: "center",
					};
					excelCell.font = {
						family: 2,
						name: "Cairo",
						size: 12,
						color: { argb: "ffffff" },
						bold: true,
					};
				}
			},
		}).then(function () {
			workbook.xlsx.writeBuffer().then(function (buffer) {
				saveAs(
					new Blob([buffer], { type: "application/octet-stream" }),
					`${sheetTitle}.xlsx`
				);
			});
		});
		e.cancel = true;
	}
}

const mapStateToProps = (state) => {
	return {
		currentUser: state.currentUser,
		reload: state.reload,
	};
};

export default connect(mapStateToProps, {
	triggerDialog,
	setLoading,
	reload,
	triggerNotification,
	triggerDialogForm,
})(translationHook(DonationTypesList));
